import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { OBPPUserAccountSummaryService } from 'src/app/services/account-summary/account-summary.service';
import { OBPPLoginService } from 'src/app/services/login-page/login-page.service';
import { DataSharingService } from 'src/app/services/login-page/data-sharing.service';
import { INVOICE_LEVEL_PAYNOW } from 'src/app/common/constants/constants';

export interface AccountSummaryResolved {
  useInvoiceLevelView: boolean;
  openedSummaryResponse: any;
  uname: string;
}

@Injectable({ providedIn: 'root' })
export class AccountSummaryResolver implements Resolve<AccountSummaryResolved> {
  constructor(
    private accountSummaryService: OBPPUserAccountSummaryService,
    private loginService: OBPPLoginService,
    private dataSharingService: DataSharingService
  ) {}

  resolve(): Observable<AccountSummaryResolved> {
    const uname = this.loginService.getIsViewOnly()
      ? this.loginService.getLookupUserName()
      : this.loginService.getUserName();

    this.dataSharingService.IsLoadingEnabled.next(true);

    return this.accountSummaryService.getUserAccountSummaryByEmail(uname).pipe(
      map((res: any) => {
        const isInvoiceLevelPaynow = res?.serviceResponse?.type === INVOICE_LEVEL_PAYNOW;
        return {
          useInvoiceLevelView: isInvoiceLevelPaynow !== undefined ? !!isInvoiceLevelPaynow : false,
          openedSummaryResponse: res,
          uname,
        };
      }),
      catchError(() =>
        of({
          useInvoiceLevelView: false,
          openedSummaryResponse: { serviceResponse: { type: 'error', object: [] } },
          uname,
        } as AccountSummaryResolved)
      ),
      finalize(() => this.dataSharingService.IsLoadingEnabled.next(false))
    );
  }
}
